import EventPage from './messageEvents/EventPage';
import MessageEventsPage from './messageEvents/MessageEventsPage';

export default {
  EventPage,
  MessageEventsPage
};
